import { useContext, type ElementType, type PropsWithChildren } from "react";

import { motion } from "motion/react";

import type { PolymorphicProps } from "shared/types";

import { cn } from "shared/utils/cn";

import { TabsContext } from "./context";
import { activeElementVariants, tabVariants } from "./styles";

type Props = {
  className?: string;
  disabled?: boolean;
  isActive?: boolean;
  onClick?: () => void;
};

export const Tab = <E extends ElementType = "li">(
  props: PropsWithChildren<PolymorphicProps<E, Props>>
) => {
  const {
    as: Comp = motion.li,
    children,
    className,
    isActive: isActiveProp = false,
    isCaution,
    onClick,
    disabled,
    ...restProps
  } = props;

  const { lineLayoutId, variant } = useContext(TabsContext);

  const isActive = isActiveProp;

  return (
    <Comp
      className={cn(tabVariants({ className, isActive, disabled, variant }))}
      onClick={onClick}
      style={{
        WebkitTapHighlightColor: "transparent",
      }}
      {...restProps}
    >
      <span className="z-10 bg-transparent">{children}</span>
      {isActive && (
        <motion.span
          className={cn(activeElementVariants({ variant }))}
          layoutId={`line-${lineLayoutId}`}
          transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
        />
      )}
      {/* {isActive && (
        <motion.span
          className="bg-basketBallOrange absolute inset-x-0 -bottom-px z-10 h-0.5"
          layoutId={`line-${lineLayoutId}`}
          transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
        />
      )} */}
    </Comp>
  );
};
